import { useDispatch } from "react-redux";

import { setLayoutDashboardTitle } from "../../store/ui-slice";
import { useEffect } from "react";
import ServiceKendaraanMain from "../../features/service-kendaraan/components/service-kendaraan-main";

const title = "Service Kendaraan";

const ServiceKendaraanPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <ServiceKendaraanMain />;
};
export default ServiceKendaraanPage;
